import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { TagModule } from 'primeng/tag';
import { BehaviorSubject, Observable } from 'rxjs';
import { getTrackModeI18nKey } from '../../../../utils/booking-track-mode.util';

@Component({
  selector: 'client-class-booking-v2-indicators-cell',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TagModule, TranslateModule, AsyncPipe],
  template: `
    @if ({ row: columnData | async }; as $) {
      @if ($.row) {
        <div class="flex flex-wrap gap-1">
          @if ($.row.class_booking_is_waitlist) {
            <p-tag
              severity="warn"
              styleClass="text-xxs"
              [value]="'CLIENT_BOOKING.V2.WAITLIST' | translate"
            />
          }
          @if ($.row.trial_id > 0) {
            <p-tag
              severity="info"
              styleClass="text-xxs"
              [value]="'CLIENT_BOOKING.V2.TRIAL' | translate"
            />
          }
          @if ($.row.class_booking_is_first_time_class) {
            <p-tag
              severity="info"
              styleClass="text-xxs"
              [value]="'CLIENT_BOOKING.V2.FIRST_TIME' | translate"
            />
          }
          @if ($.row.class_booking_is_payment_required) {
            <p-tag
              severity="danger"
              styleClass="text-xxs"
              [value]="'CLIENT_BOOKING.V2.PAYMENT_PENDING' | translate"
            />
          }
          @if (trackModeKey($.row)) {
            <p-tag
              severity="secondary"
              styleClass="text-xxs"
              [value]="trackModeKey($.row) | translate"
            />
          }
        </div>
      }
    }
  `,
})
export class ClientClassBookingV2IndicatorsCellComponent {
  columnData: Observable<unknown> = new BehaviorSubject(null);

  trackModeKey(row: { created_track_mode?: unknown }): string {
    return getTrackModeI18nKey(
      row.created_track_mode as Parameters<typeof getTrackModeI18nKey>[0],
    );
  }
}
